import { render, staticRenderFns } from "./MedicinesTypeForm.vue?vue&type=template&id=00e84070&"
import script from "./MedicinesTypeForm.vue?vue&type=script&lang=js&"
export * from "./MedicinesTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports